<template>
  <div class="transport-content">
    <vxe-toolbar>
      <template v-slot:buttons>
        <!-- 订单状态 已完成 作废 不允许新建 -->
        <!-- <el-button :disabled="saveDisabledFlag" @click="add" type="primary">新建服务</el-button> -->
        <el-button @click="add" type="primary" :disabled="turnType === '3'">新建服务</el-button>
        <!-- <el-button :disabled="testFlag" @click="edit" type="primary">编辑服务</el-button> -->
        <el-button @click="edit" type="primary" :disabled="turnType === '3'">编辑服务</el-button>
        <!-- <el-button :disabled="deleteDisabledFlag" @click="deleteFun" type="danger"
          >删除服务</el-button
        > -->
        <el-button @click="deleteFun" type="danger" :disabled="turnType === '3'"
          >删除服务</el-button
        >
        <el-button @click="handleImport" type="primary" :disabled="turnType === '3'"
          >导入</el-button
        >
        <el-button v-if="turnType != '0' && generalType" @click="handleExport" type="primary">
          导出
        </el-button>
        <el-button @click="handleCopy" type="primary" :disabled="turnType === '3'">复制</el-button>
        <el-button v-if="turnType === '3'" @click="handleDetail" type="primary">查看详情</el-button>
      </template>
    </vxe-toolbar>
    <vxe-table
      align="left"
      show-header-overflow
      :auto-resize="true"
      border
      resizable
      show-overflow
      highlight-hover-row
      size="mini"
      ref="serviceTable"
      class="vxe-table-element"
      :data="tableData"
      @select-change="handleSelectionChange"
    >
      <vxe-table-column type="checkbox" width="60" fixed="left"></vxe-table-column>
      <vxe-table-column type="index" width="60" title="序号"></vxe-table-column>
      <vxe-table-column
        v-for="(item, index) in transColumn"
        :key="index"
        :type="item.type"
        :visible="item.visible"
        :fixed="item.fixed"
        :width="item.width"
        :field="item.field"
        :title="item.title"
      >
        <template slot-scope="scope">
          <span v-if="item.field == 'qtyUnit'">{{
            transferSelect(scope.row.qtyUnit, numberUnitList)
          }}</span>
          <span v-else-if="item.field == 'roughWeightUnit'">{{
            transferSelect(scope.row.roughWeightUnit, weightUnitList)
          }}</span>
          <span v-else-if="item.field == 'netWeightUnit'">{{
            transferSelect(scope.row.netWeightUnit, weightUnitList)
          }}</span>
          <span v-else-if="item.field == 'volumeUnit'">{{
            transferSelect(scope.row.volumeUnit, volumeUnitList)
          }}</span>
          <span v-else-if="item.field == 'transportMode'">{{
            transferSelect(scope.row.transportMode, serviceMethodsList)
          }}</span>
          <span v-else-if="item.field == 'customerRequireModel'">{{
            transferSelect(scope.row.customerRequireModel, carList)
          }}</span>
          <span v-else-if="item.field == 'customerRequireSize'">{{
            transferSelect(scope.row.customerRequireSize, weightList)
          }}</span>
          <span v-else-if="item.field == 'instructStatus'">{{
            transferSelect(scope.row.instructStatus, instructStatusList)
          }}</span>
          <span v-else>{{ scope.row[item.field] }}</span>
        </template>
      </vxe-table-column>
    </vxe-table>
    <GeneralServicesDialog
      v-if="dialogVisible"
      ref="GeneralServicesDialogRefs"
      @submit="submit"
      @close="closeDialog"
      :type="type"
      :dialogVisible="dialogVisible"
      :editFormVal="editFormVal"
      :contractRoutes="routeNameList"
      :contractCode="contractCode"
      :isEdit="isEdit"
      :isCopy="isCopy"
      :isDetail="isDetail"
      :dialogTitle="dialogTitle"
      :turnType="turnType"
      :typeList="typeList"
      :containerTypeList="containerTypeList"
    />
    <!-- 添加批量导入 -->
    <sirui-upload
      :action="type === 'general' ? highwayAction : railwayAction"
      @ossSuccess="ossSuccess"
      ref="SiruiUpload"
      :data="{ ...token, ...importExtraData }"
      source="order"
      :isShowDownTemplateBtn="true"
    ></sirui-upload>
  </div>
</template>

<script>
  import XEUtils from 'xe-utils';
  import { mapState } from 'vuex';
  import { transportColumn, truckColumn, instructStatusList } from '../data';
  import GeneralServicesDialog from './generalServicesDialog';
  import orderMixin from '@/pages/intermodality/order/orderMixin';
  import siruiUpload from '@/components/SiruiUpload';
  import API from '@/api/intermodality/order';
  import bus from '@/common/js/bus';
  export default {
    name: 'transportService',
    mixins: [orderMixin],
    props: [
      'transCurrStatus',
      'contractRelationInfo',
      'type',
      'highwayArr',
      'turnType',
      'collectArr',
      'currStatus',
    ],
    components: {
      GeneralServicesDialog,
      siruiUpload,
    },
    data() {
      return {
        load: false,
        generalData: [],
        truckData: [],
        generalMultipleSelection: {},
        selectGeneralList: [],
        truckMultipleSelection: {},
        selectTrunkList: [],
        contractCode: null,
        numberUnitList: [],
        dialogVisible: false,
        dialogTitle: '',
        isEdit: false,
        isDetail: false,
        isCopy: false,
        editFormVal: {},
        highwayAction: API.HIGHWAY_IMPORT,
        railwayAction: API.RAILWAY_IMPORT,
        typeList: [],
        instructStatusList,
        containerTypeList: [],
        importExtraData: {},
      };
    },
    computed: {
      ...mapState({
        userInfo: (state) => state.userInfo.userInfo,
      }),
      transColumn() {
        return this.type === 'general' ? transportColumn(this) : truckColumn(this);
      },
      generalType() {
        return this.type === 'general';
      },
      tableData() {
        return this.type === 'general' ? this.generalData : this.truckData;
      },
      deleteDisabledFlag() {
        let otherBtnFlag = false;
        if (this.turnType === '0' || this.turnType === '2') {
          otherBtnFlag = false;
        }
        if (this.turnType === '1') {
          if (this.transCurrStatus === 'draft') {
            otherBtnFlag = false;
          } else {
            otherBtnFlag = true;
          }
        }
        if (this.turnType === '3') {
          otherBtnFlag = true;
        }
        return otherBtnFlag;
      },
      disabledFlag() {
        //其他按钮 0 新增 可编辑 1 编辑 2 复制可编辑 3 不可编辑
        // return this.turnType === '3';
        let otherBtnFlag = false;
        if (this.turnType === '0') {
          otherBtnFlag = false;
        }
        if (this.turnType === '1') {
          if (this.currStatus === 'draft') {
            otherBtnFlag = false;
          }
          if (this.currStatus === 'part_issued') {
            if (this.transCurrStatus === 'draft') {
              otherBtnFlag = false;
            } else {
              otherBtnFlag = true;
            }
          }
          if (
            this.currStatus === 'issued' ||
            this.currStatus === 'ongoing' ||
            this.currStatus === 'completed' ||
            this.currStatus === 'invalid' ||
            this.currStatus === 'expired'
          ) {
            otherBtnFlag = true;
          }
        }
        if (this.turnType === '2') {
          otherBtnFlag = false;
        }
        if (this.turnType === '3') {
          otherBtnFlag = true;
        }
        return otherBtnFlag;
      },
      // 编辑按钮逻辑 0 新增 可编辑, 1 指令状态为已发货 运输中 已到货 已完成 不可编辑 当前状态为草稿 下发可编辑, 2 复制可编辑 3 不可编辑
      testFlag() {
        let flag = false;
        if (this.turnType === '0') {
          flag = false;
        }
        if (this.turnType === '1') {
          if (
            this.transCurrStatus === 'delivered' ||
            this.transCurrStatus === 'transit' ||
            this.transCurrStatus === 'arrived' ||
            this.transCurrStatus === 'completed'
          ) {
            flag = true;
          } else {
            flag = false;
          }
        }
        if (this.turnType === '2') {
          flag = false;
        }
        if (this.turnType === '3') {
          flag = true;
        }
        return flag;
      },
      // saveDisabledFlag() {
      //   //其他按钮 0 新增 可编辑 1 编辑 2 复制可编辑 3 不可编辑
      //   let flag = false;
      //   if (this.turnType === '0' || this.turnType === '2') {
      //     flag = false;
      //   }
      //   if (this.turnType === '1') {
      //     if ()
      //   }
      //   return flag;
      // },
      token() {
        return {
          access_token: this.userInfo.access_token,
          companyCode: this.userInfo.companyCode,
          companyName: this.userInfo.companyName,
          departmentCode: this.userInfo.departmentCode,
          departmentName: this.userInfo.departmentName,
          tenantCode: this.userInfo.tenantCode,
        };
      },
    },
    mounted() {
      // this.getRouteNameList();
      this.getUnitList();
      this.getWeightUnitList();
      this.getVolumeUnitList();
      this.getServiceMethodsList();
      this.getCarList();
      this.getWeightList();
      // if (this.turnType === '3' && this.highwayArr.length > 0) {
      //   this.generalData = this.highwayArr;
      // }
    },
    watch: {
      highwayArr(newVal) {
        this.highwayArr = newVal;
        console.log('highwayArr', newVal);
        if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
          this.highwayDetail();
        }
      },
      collectArr(newVal) {
        this.collectArr = newVal;
        if (this.turnType === '3' || this.turnType === '1' || this.turnType === '2') {
          this.collectDetail();
        }
      },
      'contractRelationInfo.contractCode': {
        handler(newVal) {
          if (newVal) {
            console.log('contractCodeChange', newVal);
            this.contractCode = newVal;
            this.clearAll();
            this.getRouteNameListFromContract(newVal);
          }
        },
        immediate: true,
      },
    },
    created() {
      bus.$on('baseBoxList', (data) => {
        this.initTypeList(data);
      });
    },
    methods: {
      editFlag(val) {
        let flag = false;
        if (this.turnType === '0') {
          flag = false;
        }
        if (this.turnType === '1') {
          if (
            val === 'delivered' ||
            val === 'transit' ||
            val === 'arrived' ||
            val === 'completed'
          ) {
            flag = true;
          } else {
            flag = false;
          }
        }
        if (this.turnType === '2') {
          flag = false;
        }
        if (this.turnType === '3') {
          flag = true;
        }
        return flag;
      },
      deleteFlag(val) {
        let otherBtnFlag = false;
        if (this.turnType === '0' || this.turnType === '2') {
          otherBtnFlag = false;
        }
        if (this.turnType === '1') {
          if (val === 'draft') {
            otherBtnFlag = false;
          } else {
            otherBtnFlag = true;
          }
        }
        if (this.turnType === '3') {
          otherBtnFlag = true;
        }
        return otherBtnFlag;
      },
      initTypeList(list) {
        const arr = [];
        list.forEach((item) => {
          arr.push({
            label: item.type,
            value: item.type,
          });
        });
        this.typeList = arr;
      },
      ossSuccess(response, file) {
        console.log(response, file, '------');
        if (response.code === 0) {
          (response.data || []).forEach((res) => {
            res.isOverdue = new Date() < new Date(res.planDeliveryDate) ? '未超期' : '已超期';
          });
          if (this.type === 'general') {
            this.generalData = [...this.generalData, ...response.data];
          }
          if (this.type === 'truck') {
            this.truckData = [...this.truckData, ...response.data];
          }
        }
      },
      highwayDetail() {
        this.generalData = this.highwayArr;
      },
      collectDetail() {
        console.log(this.collectArr, 'this.collectArr');
        this.truckData = this.collectArr;
      },
      add() {
        if (
          !this.contractRelationInfo?.contractCode ||
          this.contractRelationInfo?.contractCode?.length == 0
        ) {
          this.$message({
            showClose: true,
            message: '请先选择客户合同',
            type: 'error',
          });
          return;
        }
        if (this.generalType) {
          this.dialogVisible = true;
          this.dialogTitle = '新增普通运输服务';
          this.isEdit = false;
        } else {
          this.dialogVisible = true;
          this.dialogTitle = '新增集卡运输服务';
          this.isEdit = false;
        }
      },
      handleCopy() {
        const selectRecords = this.$refs.serviceTable.getCheckboxRecords();
        console.log(selectRecords, '1111111');
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能编辑一条数据',
            type: 'error',
          });
        }

        let item = { ...(selectRecords[0] || {}) };
        if (item) {
          delete item._XID;
          delete item.id;
          item.instructStatus = 'draft';
          item.instructCode = '';
          this.editFormVal = item;
        }

        if (this.generalType) {
          this.dialogVisible = true;
          this.dialogTitle = '复制普通运输服务';
          this.isEdit = false;
          this.isCopy = true;
        } else {
          this.dialogVisible = true;
          this.dialogTitle = '复制集卡运输服务';
          this.isEdit = false;
          this.isCopy = true;
        }
      },
      handleDetail() {
        const selectRecords = this.$refs.serviceTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能查看一条数据',
            type: 'error',
          });
        } else {
          if (this.generalType) {
            this.dialogVisible = true;
            this.dialogTitle = '查看普通运输服务';
            this.editFormVal = selectRecords[0] || {};
            this.isDetail = true;
            this.$nextTick(() => {
              this.$refs.GeneralServicesDialogRefs.formItemDisable = true;

              this.$refs.GeneralServicesDialogRefs.otherFormItem = true;
            });
          } else {
            this.dialogVisible = true;
            this.dialogTitle = '查看集卡运输服务';
            this.isDetail = true;
            this.editFormVal = selectRecords[0] || {};
            this.$nextTick(() => {
              this.$refs.GeneralServicesDialogRefs.formItemDisable = true;

              this.$refs.GeneralServicesDialogRefs.otherFormItem = true;
            });
          }
        }
      },
      edit() {
        if (
          !this.contractRelationInfo?.contractCode ||
          this.contractRelationInfo?.contractCode?.length == 0
        ) {
          this.$message({
            showClose: true,
            message: '请先选择客户合同',
            type: 'error',
          });
          return;
        }

        const selectRecords = this.$refs.serviceTable.getCheckboxRecords();
        console.log(selectRecords, '1111111');
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else if (selectRecords.length > 1) {
          return this.$message({
            showClose: true,
            message: '只能编辑一条数据',
            type: 'error',
          });
        } else {
          if (this.generalType) {
            // this.dialogVisible = true;
            // this.dialogTitle = '编辑普通运输服务';
            console.log(selectRecords[0], 'selectRecords');
            this.editFormVal = selectRecords[0] || {};
            const currInstructStatus = selectRecords[0].instructStatus;
            const editFlag = this.editFlag(currInstructStatus);
            if (editFlag) {
              return this.$message({
                showClose: true,
                message: '当前指令单状态不能编辑',
                type: 'error',
              });
            }
            this.dialogVisible = true;
            this.dialogTitle = '编辑普通运输服务';
            this.isEdit = true;
            this.$nextTick(() => {
              this.$refs.GeneralServicesDialogRefs.formItemDisable =
                (this.turnType === '1' && this.transCurrStatus === 'draft') ||
                this.turnType === '2' ||
                this.turnType === '0'
                  ? false
                  : true;
              console.log('speical', this.turnType);
              console.log(
                'spcial',
                ['draft', 'issued', 'allocated', 'dispatch', 'present'].includes(
                  this.transCurrStatus
                )
              );
              console.log('spcial', this.transCurrStatus);
              let specialArg =
                this.turnType == '1' &&
                ['draft', 'issued', 'allocated', 'dispatch', 'present'].includes(
                  this.transCurrStatus
                );
              let speicalArg2 =
                this.turnType == '1' &&
                ['draft', 'issued', 'allocated', 'dispatch', 'present'].includes(
                  currInstructStatus
                );
              this.$refs.GeneralServicesDialogRefs.otherFormItem =
                speicalArg2 || specialArg || this.turnType === '2' || this.turnType === '0'
                  ? false
                  : true;
            });
          } else {
            // this.dialogVisible = true;
            // this.dialogTitle = '编辑集卡运输服务';
            this.editFormVal = selectRecords[0] || {};
            const currInstructStatus = selectRecords[0].instructStatus;
            if (this.editFlag(currInstructStatus)) {
              return this.$message({
                showClose: true,
                message: '当前指令单状态不能编辑',
                type: 'error',
              });
            }
            this.dialogVisible = true;
            this.dialogTitle = '编辑集卡运输服务';
            this.isEdit = true;
            this.$nextTick(() => {
              this.$refs.GeneralServicesDialogRefs.formItemDisable =
                (this.turnType === '1' && this.transCurrStatus === 'draft') ||
                this.turnType === '2' ||
                this.turnType === '0'
                  ? false
                  : true;
              this.$refs.GeneralServicesDialogRefs.otherFormItem =
                (this.turnType === '1' &&
                  ['draft', 'issued', 'allocated', 'dispatch', 'present'].includes(
                    this.transCurrStatus
                  )) ||
                this.turnType === '2' ||
                this.turnType === '0'
                  ? false
                  : true;
              // this.$refs.GeneralServicesDialogRefs.formItemDisable =
              //   this.turnType === '1' && this.transCurrStatus === 'part_issued' ? true : false;
              // this.$refs.GeneralServicesDialogRefs.otherFormItem = false;
            });
          }
        }
      },
      clearAll() {
        this.tableData = [];
      },
      deleteFun() {
        const selectRecords = this.$refs.serviceTable.getCheckboxRecords();
        // const fullData = this.$refs.serviceTable.getTableData().fullData || [];
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        } else {
          const selectRecordsObj = selectRecords[0];
          if (this.deleteFlag(selectRecordsObj.instructStatus)) {
            return this.$message({
              showClose: true,
              message: '当前指令单状态不能删除',
              type: 'error',
            });
          }
          this.$confirmAction()
            .then(() => {
              // const selectRecordsObj = selectRecords[0];
              const deleteIds = selectRecords.map((v) => v._XID);
              const tempTableData = [...this.tableData];
              this.tableData.forEach((table, index) => {
                if (deleteIds.includes(table._XID)) {
                  tempTableData.splice(index, 1, null);
                }
              });
              if (this.type == 'general') {
                this.generalData = tempTableData.filter((v) => v);
              } else {
                this.truckData = tempTableData.filter((v) => v);
              }
              this.$refs.serviceTable.removeSelecteds();
              this.$message({
                showClose: true,
                type: 'success',
                message: this.$t('receivablesManage.message.deleteSuccess'),
              });
            })
            .catch(() => {});
        }
      },
      async handleImport() {
        await this.getParentProductList();
        console.log('-----', this.importProductParent);
        if (!this.importProductParent.length) {
          return this.$message.error('所选合同服务计费规则中没有商品信息,无法导入');
        } else {
          this.importExtraData = {
            mtoContract: JSON.stringify([this.importRouteName]),
            mtoContractCargos: JSON.stringify(this.importProductParent),
          };
        }
        this.$nextTick(() => {
          this.$refs.SiruiUpload.openDialog(true, this.type === 'general' ? '09' : '091');
        });
      },
      handleExport() {
        const selectRecords = this.$refs.serviceTable.getCheckboxRecords();
        if (selectRecords.length < 1) {
          return this.$message({
            showClose: true,
            message: this.$t('xTable.noSelectData'),
            type: 'error',
          });
        }
        const ids = selectRecords.map((v) => v.id);
        this.$axios.post('/order/mto/ordinary/ordinaryInstructExport', { ids }).then((res) => {
          if (res.data.code === 0) {
            window.location.href = res.data.data;
          }
        });
        // 导出接口
        // window.location.href = `${baseUrl}${this.exportAction}?${str}access_token=${this.token.access_token}`;
      },
      // 弹框抛出的数据
      submit(obj, dialogType, isEdit) {
        // 封装数据 采购组织为合同带出
        // 线路名称转换
        obj.routeName = this.transferSelect(obj.routeCode, this.routeNameList, 'code', 'name');
        // 采购组织 合同带出的值
        obj.purchaseOrgName = this.contractRelationInfo.saleDepartmentName || '合同带出的销售组织';
        obj.purchaseOrgCode =
          this.contractRelationInfo.saleDepartmentNo || '合同带出的销售组织代码';
        // 是否超期判断
        obj.isOverdue = new Date() < new Date(obj.planDeliveryDate) ? '未超期' : '已超期';
        if (isEdit) {
          // 编辑
          if (dialogType === 'general' && this.generalMultipleSelection) {
            this.generalData.forEach((generalItem) => {
              if (generalItem._XID === this.generalMultipleSelection.row._XID) {
                Object.assign(generalItem, obj);
              }
            });
          }
          if (dialogType === 'truck' && this.truckMultipleSelection) {
            this.truckData.forEach((truckItem) => {
              if (truckItem._XID === this.truckMultipleSelection.row._XID) {
                Object.assign(truckItem, obj);
              }
            });
          }
        } else {
          // 新增
          if (dialogType === 'general') {
            this.generalData.push(obj);
          } else {
            this.truckData.push(obj);
          }
        }
      },
      getSelectedList() {
        return this.$refs.serviceTable.getCheckboxRecords();
      },
      handleSelectionChange(row) {
        console.log(row, '12345---');
        if (this.type === 'general') {
          this.generalMultipleSelection = row;
          this.selectGeneralList = row.selection || [];
        }
        if (this.type === 'truck') {
          this.selectTrunkList = row.selection || [];
          this.truckMultipleSelection = row;
        }
      },
      transferSelect(value, list, valueProp = 'value', labelField = 'label') {
        let item = XEUtils.find(list, (item) => item[valueProp] === value);
        return item ? item[labelField] : null;
      },
      closeDialog() {
        this.dialogVisible = false;
        this.isCopy = false;
      },
    },
  };
</script>
